import React, {useEffect, useState} from 'react';
import {Pie} from "@ant-design/plots";
import axios from "axios";
import {API_PATH} from "../../components/const";

const VisitorPie1 = (props) => {
    const [dataObject, setDataObject] = useState({})
    const [data, setData] = useState([])
    const [time, setTime] = useState(new Date());
    let currentDay = time.getDay;
    const month = ["Янв ","Фев ","Мар ","Апр","Май","Июн","Июл ","Авг","Сен","Окт","Ноя","Дек",]
    const yesterday = new Date(time);
    yesterday.setDate(time.getDate() - 1);
    const formattedDate2 = yesterday.toISOString().split('T')[0];
    const getData = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/gender/daily?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" +  Number(time?.getDate()), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                console.log(res?.data)
                setDataObject(res?.data)
                setData([{
                    type: "Мужской",
                    value: res?.data?.current_day?.Male
                }, {
                    type: "Женский",
                    value: res?.data?.current_day?.Female
                } ])
            })
    }

    const config = {
        appendPadding: 10,
        data,
        colorfield: 'type', // or seriesfield in some cases
        color: [ '#5664D2', '#FC53F5', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        series: {
                fill: '#fff'
        },
        label: {
            type: 'inner',
            offset: '-50%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 20,
                textAlign: 'center',
                fill: '#fff'
            },
        },

        interactions: [
            {
                type: 'element-active',
            },
        ],
    };
    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="visitor-box-min">
            <div className="visitor-box-item">
                <div>
                    <h4 className="font-family-medium">Ежедневно</h4>
                </div>
                <div>
                    <h2> { Number(time?.getDate()) + " " + month[Number(formattedDate2.slice(5, 7)  - 1)] }  </h2>
                </div>
            </div>
            <div className="visitor-box-item">
                <div>
                    <h1 className="font-family-medium">{dataObject?.current_day?.Total}</h1>
                </div>
                <div>
                    <h3>
                        Посетители
                    </h3>
                    <p className={dataObject?.change?.Total?.percentage > 0 ? "up font-family-medium" : "down font-family-medium"}>{Math.floor(dataObject?.change?.Total?.percentage)   + " "}
                        {
                            dataObject?.change?.Total?.percentage  > 0 ?
                                <>
                                    % рост
                                    <img src="/icon/downa.svg" alt=""/>
                                </>
                                :
                                <>
                                    % спад  <img src="/icon/upa.svg" alt=""/>
                                </>


                        }
                    </p>
                </div>
            </div>
            <div className="visitor-box-pie">
                <Pie {...config} />
            </div>
        </div>

    );
};

export default VisitorPie1;